/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

window.addEventListener("resize", customResize);

function customResize() {
  console.log("resizing");
  var menu = document.getElementsByClassName("MegaMenu__Inner")[0];
  var children = menu.getElementsByClassName("MegaMenu__Item");
  console.log(menu.clientWidth);
  var i = 0;
  var totalWidth = 0;
  while (i < children.length) {
    totalWidth += children[i].clientWidth + 40;
    
    
    i++;
  }
  console.log(totalWidth);
  if (menu.clientWidth / totalWidth < 1) {
  	//menu.style.transform = "scale(" + menu.clientWidth / totalWidth + ")";
  	menu.style.transformOrigin = "top left";
  } else {
    menu.style.transform = "scale(1)";
  	menu.style.transformOrigin = "top left";
  }
}

customResize();